import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ajustarPontosCliente from '../../actions/adesao-pontos/ajustarPontosCliente';
import buscarClientesPorEmpresa from '../../actions/adesao-pontos/buscarClientesEmpresa';
import { showSuccessMsg } from '../../util/messagesUtil';
import { formatPontos } from '../../util/numberUtil';

const TIPOS = [
    { value: 'CREDITAR', label: 'Creditar pontos', icon: 'add_circle', color: '#28a745' },
    { value: 'DEBITAR', label: 'Debitar pontos', icon: 'remove_circle', color: '#dc3545' },
];

export class ModalTrocarPontosCliente extends Component {
    constructor(props) {
        super(props);
        this.state = { tipo: 'CREDITAR', quantidade: '', justificativa: '', salvando: false };
        this.fecharModal = this.fecharModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.cliente && this.props.cliente !== prevProps.cliente) {
            this.setState({ tipo: 'CREDITAR', quantidade: '', justificativa: '' });
        }
    }

    fecharModal() {
        $('#modalTrocarPontosCliente').modal('hide');
        $('#modalTrocarPontosCliente').hide();
        $('.modal-backdrop').hide();
    }

    submit(e) {
        e.preventDefault();
        const { cliente, empresaSelecionada } = this.props;
        if (!cliente) return;
        this.setState({ salvando: true });
        const ajuste = {
            tipo: this.state.tipo,
            quantidade: parseInt(this.state.quantidade),
            justificativa: this.state.justificativa,
        };
        this.props.ajustarPontosCliente(empresaSelecionada.id, cliente.id, ajuste)
            .then(() => {
                showSuccessMsg('Pontos ajustados com sucesso!');
                this.fecharModal();
                this.props.buscarClientesPorEmpresa(empresaSelecionada.id);
            })
            .finally(() => this.setState({ salvando: false }));
    }

    render() {
        const { cliente } = this.props;
        const { tipo, quantidade, justificativa, salvando } = this.state;

        return (
            <div className="modal fade show" id="modalTrocarPontosCliente" role="dialog"
                aria-labelledby="modalTrocarPontosCliente" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">

                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">swap_horiz</i>
                                <span className="vx-modal-title">Ajuste de Pontos</span>
                            </div>
                            <button type="button" className="vx-modal-close" onClick={this.fecharModal}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        <div className="vx-modal-body">
                            {cliente && (
                                <form id="form-trocar-pontos-cliente" onSubmit={this.submit}>

                                    {/* Resumo do cliente */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: '#f8f9fa', borderRadius: 8, marginBottom: 20, border: '1px solid #eee' }}>
                                        <i className="material-icons" style={{ color: 'var(--vx-primary)', fontSize: 28 }}>person</i>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: 700, fontSize: 14 }}>{cliente.nome}</div>
                                            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                                                Saldo atual:&nbsp;
                                                <span className="vx-pts-badge vx-pts-badge--green" style={{ marginRight: 6 }}>
                                                    <i className="material-icons" style={{ fontSize: 11 }}>star</i>
                                                    {formatPontos(cliente.pontosDisponiveis)} disponíveis
                                                </span>
                                                <span className="vx-pts-badge vx-pts-badge--red">
                                                    <i className="material-icons" style={{ fontSize: 11 }}>lock</i>
                                                    {formatPontos(cliente.pontosCongelados)} congelados
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tipo do ajuste */}
                                    <div style={{ marginBottom: 16 }}>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 8 }}>Operação:</label>
                                        <div className="vx-radio-cards">
                                            {TIPOS.map(t => {
                                                const selected = tipo === t.value;
                                                return (
                                                    <div key={t.value}
                                                        className={`vx-radio-card${selected ? ' vx-radio-card--selected' : ''}`}
                                                        onClick={() => this.setState({ tipo: t.value })}>
                                                        <div className="vx-radio-card-title">
                                                            <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 5, color: selected ? t.color : '#ccc' }}>
                                                                {selected ? 'radio_button_checked' : 'radio_button_unchecked'}
                                                            </i>
                                                            <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 5, color: t.color }}>{t.icon}</i>
                                                            {t.label}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Quantidade */}
                                    <div style={{ marginBottom: 16, maxWidth: 220 }}>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Quantidade de pontos:</label>
                                        <input type="number" className="form-control" min="1"
                                            value={quantidade}
                                            onChange={e => this.setState({ quantidade: e.target.value })}
                                            required placeholder="Ex: 1000" />
                                    </div>

                                    {/* Justificativa */}
                                    <div style={{ marginBottom: 8 }}>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Justificativa:</label>
                                        <textarea className="form-control" rows={3}
                                            value={justificativa}
                                            onChange={e => this.setState({ justificativa: e.target.value })}
                                            required placeholder="Descreva o motivo do ajuste..." />
                                    </div>
                                </form>
                            )}
                        </div>

                        <div className="vx-modal-footer">
                            <button type="button" className="vx-btn-secondary" onClick={this.fecharModal}>
                                Cancelar
                            </button>
                            <button type="submit" form="form-trocar-pontos-cliente"
                                disabled={salvando || !quantidade}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: 16 }}>check</i>
                                {salvando ? 'Salvando...' : 'Confirmar Ajuste'}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { empresaSelecionada: state.empresaSelecionada };
}

export default withRouter(connect(mapStateToProps, {
    ajustarPontosCliente,
    buscarClientesPorEmpresa,
})(ModalTrocarPontosCliente));
